import { render, staticRenderFns } from "./EmptyListData.vue?vue&type=template&id=d28207a4&scoped=true&"
import script from "./EmptyListData.vue?vue&type=script&lang=js&"
export * from "./EmptyListData.vue?vue&type=script&lang=js&"
import style0 from "./EmptyListData.vue?vue&type=style&index=0&id=d28207a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28207a4",
  null
  
)

export default component.exports